import { get } from "./ajax"
const getUrlParams = function () {
let Params = {};
let href = decodeURIComponent(decodeURIComponent(location.href));
let search;
let strs;
//微信获取openId，跳转回来后，会在 # 前带上参数如 ?from=，影响参数获取，因此过滤掉
if(href.split("?").length -1 > 1){
href = href.replace(/\?.+?\#/,"");
}
if (href.indexOf("?") != -1) {
search = href.slice(href.indexOf("?") + 1)
strs = search.split("&");
}
if (search) {
for (var i = 0; i < strs.length; i++) {
Params[strs[i].match(/(.+?)=(.+)/)[1]] = unescape(strs[i].match(/(.+?)=([^&|^?]*)/)[2]);
}
console.log('获取url参数：');
console.log(Params);
}
return Params;
}


const isWeiXin = function () {
	//判断是否微信浏览器打开
	var ua = window.navigator.userAgent.toLowerCase()
	if (ua.match(/MicroMessenger/i) == 'micromessenger') {
		return true
	} else {
		return false
	}
}
const commonShare = (shareURL,shareTitle,shareContent,localLink) => {
	var isWx = isWeiXin()
	if(isWx) { //微信打开
		window.sessionStorage.setItem('noLogin', true)
		get("https://www.b100y.com/truck-api/v002/commentLottoController/getJsApiParam",
			{
				type : 3,
				url : location.href
			},
			data => {
				window.sessionStorage.removeItem('noLogin')
				wx.config({
					debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
					appId: data.appId, // 必填，公众号的唯一标识
					timestamp: data.timestamp, // 必填，生成签名的时间戳
					nonceStr: data.nonceStr, // 必填，生成签名的随机串
					signature: data.signature, // 必填，签名，见附录1
					jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'openLocation', 'getLocation'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
				});
				wx.error(function(err) {
					// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
				});
				wx.ready(function(res) {
					/*分享给朋友*/
					wx.onMenuShareAppMessage({
						title: shareTitle, // 分享标题
						// desc: '来这里找最好的物流专线', // 分享描述
						desc: shareContent,
						link: shareURL, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致

						imgUrl: 'https://www.b100y.com/h5/parkmall/images/sharelogo.png', // 分享图标
						type: '', // 分享类型,music、video或link，不填默认为link
						dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
						success: function(data) {
							
						},
						cancel: function() {
							// 用户取消分享后执行的回调函数
						},
						fail: function(res) {
							
						}
					});

					//分享到朋友圈
					wx.onMenuShareTimeline({
						title: shareTitle, // 分享标题
						link: shareURL, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致

						imgUrl: 'https://www.b100y.com/h5/parkmall/images/sharelogo.png', // 分享图标
						success: function(res) {
							
						},
						cancel: function() {
							// 用户取消分享后执行的回调函数
							
						}
					});
				});
			},
	        error => {
	        	
	        }
	     )
	}
  	
}
export {
	commonShare,
  	isWeiXin,
  	getUrlParams
}
